import { render } from "./ComponentForm.vue?vue&type=template&id=2f7128da"
import script from "./ComponentForm.vue?vue&type=script&lang=js"
export * from "./ComponentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__